import { loadable } from "@faire/retailer/lib/loadable";
import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";
import { IShowroomProductMedia } from "@faire/retailer/views/product/ProductImages/utils";

export interface IProps {
  index: number;
  productMedia: IShowroomProductMedia[];
  onChangeIndex: (value: number) => void;
  onClose: () => void;
  eventName: string;
}

export const LazyImageGallery = loadable(
  () => import("./ImageGallery").catch(handleComponentLoadError),
  {
    resolveComponent: (m) => m.ImageGallery,
  }
);
